import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsUsuarioClienteClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async findAll(queries = {}) {
    try {
      return await this.api.get('/parametros', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab');
    }
  }

  async create(data) {
    try {
      const { data: response } = await this.api.post('/parametros', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Tipo Pedido Estab');
    }
  }

  async findByDescricao(descricao) {
    try {
      const { data } = await this.api.get(`/parametros/find?parametro=${descricao}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tipo Pedido Estab');
    }
  }
}
